<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xvi"></a><a id="page_xvii"></a><a id="page_xviii"></a>MOSES MENDELSSOHN’S LIVING SCRIPT</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle01.vue?21406d0c